/**
 *
 * Collapse is used to hide and show items in filters
 *
 */


module.exports = {

  init: function () {
    var className = 'mywort-collapse';
    $('.' + className).each(function () {
      var that = this;
      let header = $(this).find('.' + className + '__header')[0];
      $(header).click(function(){
        let content = $(that).find('.' + className + '__content')[0];
        $(content).slideToggle(200);
        $(that).toggleClass(className + '--expanded');
      });
    });
  }
};



// WEBPACK FOOTER //
// ./js/mywort/styleguide/collapse.js